
import { defineComponent } from 'vue';
import { string } from 'vue-types';
import { LicensePageMetaItemRegularContent } from '../types';

export default defineComponent({
  name: 'LicensePageMetaContentRegular',
  props: {
    content: string<LicensePageMetaItemRegularContent['content']>().isRequired
  }
});
